import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import * as anchor from "@project-serum/anchor";
import Divider from '@mui/material/Divider';
import { Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Content from '../Content/Content';
import { useTranslation } from 'react-i18next'

//
export default function Breeding(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    return (
        <Content>
            <h1 color='blue'>{t("breeding.mainHeader")}</h1>

            <Divider sx={{ background: "#2f3f60", paddingBottom: "10px", marginBottom: "10px" }} />

            <Typography align="justify" paragraph={true}>
                {t("breeding.bodyText1")}
            </Typography>

            <h2>{t("breeding.header1")}</h2>

            <Typography align="justify" paragraph={true}>
                {t("breeding.bodyText2")}
            </Typography>
        </Content>
    );
}
